import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, Image } from "@chakra-ui/react";
import "./Carousel.css"; // Import the CSS file here

const Carousel = ({ data }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    <Box m={"auto"} className="craousel">
      <Slider {...settings}>
        {data.map((el) => (
          <Box key={el.id}>
            {" "}
            <Image
              className="Img"
              w={["80%", "89%", "90%", "90%", "100%"]}
              // mr={["20px","","","",""]}
              m="auto"
              src={el.name}
              alt={el.name}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default Carousel;
